export default {
    background: '#F0F0F0',
    primary: '#008941',
    white: '#fff',
}